import { Component, OnDestroy, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { KnBrProductSelectService } from 'src/feature-libs/kn-br-product/core/service/kn-br-product-select.service';
import { KnBrProductGridItemComponent } from 'src/feature-libs/kn-br-product/components/kn-br-product-list/kn-br-product-grid-item/kn-br-product-grid-item.component';
import { MediaComponent } from '@spartacus/storefront';
import { SloanAddToCartComponent } from '../../sloan-add-to-cart/sloan-add-to-cart.component';
import { SloanAddToQuoteComponent } from '../../sloan-add-to-quote/sloan-add-to-quote.component';

@Component({
    selector: 'kn-br-product-grid-item',
    templateUrl: './sloan-product-grid-item.component.html',
    styleUrls: ['./sloan-product-grid-item.component.scss'],
    imports: [MediaComponent, SloanAddToCartComponent, SloanAddToQuoteComponent]
})
export class SloanProductGridItemComponent extends KnBrProductGridItemComponent implements OnDestroy {
  constructor(protected productSelectService: KnBrProductSelectService, protected routingService: RoutingService) {
    super(productSelectService, routingService);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addProductCode() {
    if (
      this.product.isOrderable &&
      this.product.price &&
      (this.product.price.formattedPrice || this.product.price.formattedValue)
    ) {
      if (this.selectedProductsCodes && this.selectedProductsCodes.length) {
        this.selectedProductsCodes.push(this.product.code);
      } else {
        this.selectedProductsCodes = [this.product.code];
      }
    }
    return this.selectedProductsCodes;
  }
}
